import React from 'react';
import { Shield, Lock, Server, FileCheck } from 'lucide-react';
import './CredibilityStrip.css';

const CredibilityStrip = () => {
  const items = [
    { icon: Server, text: 'Built for AI-driven organizations' },
    { icon: Shield, text: 'Governance-first architecture' },
    { icon: Lock, text: 'Enterprise-grade communication control' },
    { icon: FileCheck, text: 'Policy-driven oversight' },
  ];

  return (
    <section className="credibility-strip" data-testid="credibility-strip">
      <div className="container">
        <div className="credibility-grid">
          {items.map((item, index) => (
            <div key={index} className="credibility-item" data-testid={`credibility-item-${index}`}>
              <item.icon size={20} className="credibility-icon" />
              <span className="credibility-text">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CredibilityStrip;
